import { US_COUNTRY_CODE } from '../constants/data';
import { Company } from '../types/companyUser';

// Single source of truth for whether a company can see and reach the Invoicing section.
// Used by both the sidebar (AppMenu) and the route guard (InvoicingAccessGuard).
export const canAccessInvoicing = (company?: Company): boolean =>
  company?.country === US_COUNTRY_CODE &&
  !!company?.productStatus?.readyForBanking &&
  !!company?.productStatus?.hasStartedBanking;
